// extracted by mini-css-extract-plugin
export default {"root":"IconAccount_root__qOABC"};